





































































import CustomValueDisplay from "@/common/ui/components/CustomValueDisplay.vue";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {
    CustomValueDisplay
  }
})
export default class SalesReportSummary extends Vue {
  @Prop({ required: true }) data!: any;

  tagName: string = "dd";
  formatCurrency(value: any) {
    if (value === "-") return "ー";
    return value || value === 0 ? "￥" + parseInt(value).toLocaleString() : "";
  }

  isNegative(value: any) {
    return parseFloat(value) < 0;
  }
}
